module.exports = __webpack_public_path__ + "static/WEDDING E&M-385-a2281c5605db2bd8052d00ead952496b.jpg";